import { Component, Vue } from "vue-property-decorator";

@Component
export default class CompanyMixin extends Vue {
  public get hasNotPermissionWrite(): boolean {
    return !this.$can(this.MODULE_COMPANY_WRITE);
  }
}
